import { Button, alpha } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { green } from "./../../themes/colors";

export default withStyles(theme => {
    const isDark2 = theme.palette.background.default === '#202326';
    const success = isDark2
        ? { main: '#4f7d65', dark: '#3d634f', contrastText: '#ffffff' }
        : green;

    return {
        text: {
            color: success.main,
            '&:hover': {
                backgroundColor: alpha(success.main, theme.palette.action.hoverOpacity),
            }
        },
        outlined: {
            color: success.main,
            border: `1px solid ${alpha(success.main, 0.5)}`,
            '&:hover': {
                border: `1px solid ${success.main}`,
                backgroundColor: alpha(success.main, theme.palette.action.hoverOpacity),
            }
        },
        contained: {
            color: success.contrastText,
            backgroundColor: success.main,
            '&:hover': {
                backgroundColor: success.dark
            },
            '&:disabled': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                color: '#999999'
            },
        }
    };
}, { name: 'MuiButton-Success' })(Button);